import React, {  useEffect, useState } from 'react'
import axios from 'axios'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { FilterMatchMode } from 'primereact/api';
import { NavLink } from 'react-router-dom';
import moment from 'moment';

export const RunAOsComponent = () => {

    const [aosLoad, setAosLoad] = useState();

    useEffect(() => {
        axios.get("/api/aosruns/getall")
            .then(response => setAosLoad(response.data))
    }, []);

    const nomLink = runAo => {
        if (runAo.isFailed) {
            return <span>runAO.nom</span>
        }
        else {
            return <NavLink to={"/aos/result/" + runAo.id} >{runAo.nom}</NavLink>
        }
    }

    const isValidIcon = runAo => {
        if ((!runAo.isFinished || !runAo.isCalculated ) && !runAo.isInTimeForCalculating) {
            return <i className="pi pi-minus-circle text-danger" ></i>
        }

        if (!runAo.isFinished || !runAo.isCalculated) {
            return <i className="bi bi-arrow-repeat text-primary"  ></i>
        }
        else if (runAo.isSuccessCalculated) {
            return <i className="pi pi-check-circle text-success"  ></i>
        }
        else if (runAo.isCalculatedFinished && !runAo.isCalculatedSucces) {
            return <i className="pi pi-minus-circle text-danger" ></i>
        }
        else if (runAo.isSuccess) { 
                return <i className="pi pi-chevron-down text-success"  ></i>
        }
        else {
                return <i className="pi pi-minus-circle text-danger" ></i>
        }
    }

    const formatDate = runAO => {
        return <>{ moment(runAO.date).format('ll') }</>
    }

    const formatLastCalculationDateDate = runAO => {

        if (!runAO.lastCalculationDate) {
            return <></>
        }

        return <>{moment(runAO.lastCalculationDate).format('lll')}</>
    }

    const [filters] = useState({

        nom : { value: null, matchMode: FilterMatchMode.STARTS_WITH },

        compte : { value: null, matchMode: FilterMatchMode.STARTS_WITH },

        errorMessage: { value: null, matchMode: FilterMatchMode.CONTAINS },

    });



    return <div >
        <div className="alert alert-info">
            Vous trouverez ici la liste des derniers runs sur les 30 derniers jours.<br />
            Lorsque le run est un échec un message indique pourquoi.<br />
            En cliquant sur le nom, vous accéderez au détail des appels d'offres du run.
        </div>
    
        <DataTable value={aosLoad} tableStyle={{ width: '100%' }} 
            filters={ filters } filterDisplay="row">
            <Column field="nom" header="Titre" filter sortable body={ nomLink } />
            <Column field="compte" header="Compte" filter sortable />
            <Column field="uploadBy" header="Uploadé par" filter sortable />
            <Column field="date" header="Date" sortable body={formatDate} />
            <Column field="lastCalculationDate" header="Dernier calcul" sortable body={formatLastCalculationDateDate} />
            <Column field="errorMessage" header="Message d'erreur" filter />
            <column field="isCompletlyParsed" header="Status" sortable body={ isValidIcon } />
        </DataTable>
    </div>
}